bq.bundle = {
  $element: false,

  options: {
    specTemplate: '<p title="%title%"><span>%qty% x %name%</span><strong>%price%</strong></p>',
    specContainer: '.sidebar-specs-detail',
    disabledTitle: 'Quantity not editable for this item',
    notActiveTitle: false,
    qtyInput: '.option-qty',
    qtyStatic: '.option-qty-static',
    input: '.option-input',
    dropdown: 'select.option-input',
    dropdownWrapper: '.bundle-option-select-container',
    inputParent: '.input-group:not(.date)',
    priceDisplay: '.option-price',
    nameStatic: '.option-name-static',
    inputParentConfigure: '.input-group.configure',
    configureOption: '.configure-option',
    customOptionTextType: '.text-type',
    customOptionDateType: '[data-provide="datepicker"]',
    noSpecs:'<div class="alert alert-info">No Data Available.</div>',
    tooltip: true,
    basePrices: [],
    validateErrorMessage: '',
    items: [],
    bundleToggleAll: '.bundle-toggle-all'
  },

  init: function(el) {
    if(!el || $(el).data('bundle')) { return; }
    this.$element = $(el);

    bq.debug.log("marketplace.bundle : init()", this.$element);

    var $this = this;

    $(this.options.dropdown).on('change', {thiz: $this},  this.catchEventChangeDropdown);
    this.$element.on('change', {thiz: $this},  this.catchEventChange);
    this.$element.on('bq.bundle.item.validate', {thiz: $this},  this.catchEventValidateBundleItem);

    $(this.options.qtyInput, this.$element).each(function(){
      $this.$element.on('keyup', {thiz: $this},  $this.catchEventKeyUp);
      $this._recalculate($(this));

    });

    $(this.options.customOptionTextType, this.$element).each(function(){
        $this.$element.on('keyup', {thiz: $this},  $this.catchEventKeyUpCustomOption);
    });

    $(this.options.customOptionDateType, this.$element).each(function(){
        $this.$element.on('dp.change', {thiz: $this},  $this.catchEventKeyUpCustomOption);
    });

    $(this.options.bundleToggleAll).on('click', {thiz: $this}, $this.catchToggleAll);

    this.$element.on('reset', {thiz: $this}, $this.catchEventFormReset);

    this._disableInputs();
    this._updateSpecs();
    this._setPrices();
    this._setItems();
  },

  _disableInputs: function() {
    var $this = this;

    $(this.options.qtyInput).each(function(){
      var input = $(this).closest($this.options.inputParent).find($this.options.input);
      var active = $this._isActive(input);

      if(active === true) {
        $this._enable($(this));
      } else if(active === 'disable') {
        $this._disable($(this), $this.options.disabledTitle);
      } else { //readonly
        $this._disable($(this), $this.options.notActiveTitle);
      }
    });
  },

  _disable: function(input, message) {
    if(this.options.tooltip) { input.tooltip('destroy'); }
    if(this.options.tooltip && message) { input.tooltip({container: 'body', title: message}); }
    input.prop('readonly', 'readonly');

  },

  _enable: function(input) {
    if(this.options.tooltip) { input.tooltip('destroy'); }
    input.prop('readonly', false);
  },

  _recalculate: function(qty) {
    var input = qty.closest(this.options.inputParent).find(this.options.input);
    if(input.is('select')) {
      input = input.find('option:selected');
    }

    var priceDisplay = qty.closest(this.options.inputParent).find(this.options.priceDisplay);

    if(qty.closest(this.options.dropdownWrapper).length > 0) {
      input = qty.closest(this.options.dropdownWrapper).find('.bundle-option-select-wrapper select option:selected');
      priceDisplay = qty.closest(this.options.dropdownWrapper).find(this.options.priceDisplay);
    }

    var singlePrice = input.data('singlePrice');
    var tierPrices = input.data('tierPrice');
    var selectedOptionsPrice = input.data('selectedOptionsPrice') ? input.data('selectedOptionsPrice') : 0;
    singlePrice += selectedOptionsPrice;
    if (tierPrices) {
        $(tierPrices).each(function (index, tierPrice) {
            var tierPriceValue = tierPrice['price'] + selectedOptionsPrice;
            if (tierPrice['qty'] <= qty.val() && tierPriceValue < singlePrice) {
                singlePrice = tierPriceValue;
            }
        });
    }

    var newPrice = accounting.formatMoney(qty.val() * singlePrice);

    if(accounting.unformat(input.data('price')) != accounting.unformat(newPrice)) {
      input.data('price', accounting.unformat(newPrice));
    }

    priceDisplay.html(newPrice);

    bq.helper.throwEvent('change', priceDisplay.closest('form'));

  },

  _updateSelect: function(select) {
    if(!select.is('select')) { return false; }
    var option = select.find("option:selected");
    var parent = select.closest(this.options.inputParent);
    if(option.data('qty')) {
      var qty = parent.find(this.options.qtyInput);
      qty.val(option.data('qty'));
      qty.attr('min', option.data('min-qty'));
      qty.attr('max', option.data('max-qty'));
      qty.addClass('bundle-revalidate');
      qty.parsley('reset');
      this._recalculate(qty);
    }
  },

  _updateRadio: function(element) {
    if (!element.is(':radio')) {
      return false;
    }
    var $this = this;
    $('input[type="radio"][name="' + element.prop('name') + '"]', $this.$form)
      .not(element)
      .each(function() {
        var option = $(this);
        if ($this._isBundleConfigureItem(option)) {
          $this._manageCustomOptions(option);
          option.closest('div')
              .find('[data-toggle="collapse"]')
              .not('.collapsed')
              .click();
        }
      });
  },

  _updateSpecs: function() {
    var specHolder = $(this.options.specContainer, this.$element);
    var specHTML = '';
    var $this = this;

    $(this.options.input, this.$element).each(function(){
      var el = $(this);
      var parent = el.closest($this.options.inputParent);
      var price = parent.find($this.options.priceDisplay).html();
      var qty = false;
      var name = false;
      var isSelect = false;
      var tmpQty = parent.find($this.options.qtyStatic);
      var nameContainer = null;

      if(tmpQty.length == 1) {
        qty = tmpQty.html();
      } else {
        qty = parent.find($this.options.qtyInput).val();
      }

      if(el.is('select') && $('option:selected', el).attr('value')) {
        name = el.find('option:selected').text();
        isSelect = true;
      } else {
        nameContainer = parent.find($this.options.nameStatic);
        if (nameContainer.find('a').length) {
          name = nameContainer.find('a').html();
        } else {
          name = nameContainer.html();
        }
      }

      if($this._validateData(el, name, price, qty, isSelect)) {

        var tmpl = $this.options.specTemplate;
        tmpl = tmpl.replace('%qty%', qty);
        tmpl = tmpl.replace('%price%', price);
        tmpl = tmpl.replace('%name%', name);
        tmpl = tmpl.replace('%title%', name);

        specHTML += tmpl;
      }
    });

    if(specHTML === '') { specHTML = this.options.noSpecs; }
    specHolder.html(specHTML);

  },

  _validateData: function(el, name, price, qty, isSelect) {
    //bq.debug.log('validating: ', name, price, qty, isSelect);
    if(isSelect && el.find('option:selected').val() === '') { return false; }
    if(!isSelect && !el[0].checked) { return false; }

    if(!name || name === '') { return false; }
    if(!price) { return false; }
    if(!qty || isNaN(qty) || qty === 0) { return false; }

    return true;
  },

  _isActive: function(input) {
    var active = false;
    if(input.is('select')) {
      active = input.find('option:selected').data('changeQty');
      if(active) { return true; } else { return 'disable'; }
    }

    if(input[0].checked) {
      active = input.data('changeQty');
      if(active) { return true; } else { return 'disable'; }
    }

    return 'readonly'; //'disable', true, 'readonly'
  },

  _setPrices: function(){
    var $this = this;

    $('[data-price]', this.$form).each(function(){
      var el = $(this);
      var value = $this._getElementValue(el);

      if(value !== '') {
        var price = el.data('price');
        if (el.data('single-price')){
            price = el.data('single-price');
        }
        var elPrice = $this._getPrice(price);
        var elId = value;

        $this.options.basePrices[elId] = $this._getPrice(elPrice);
      }
    });

    return true;
  },

  _setItems: function() {
    var $this = this;

    $('input[type="checkbox"][data-price]', this.$form).each(function() {
      $this.options.items.push($(this));
    });
  },

  _getPrice: function(price) {
    var newPrice = parseFloat(accounting.unformat(price));
    if(isNaN(newPrice) || newPrice < 0) { newPrice = 0; }
    return newPrice;
  },

  _isCustomOption: function(option){
    var isCustomOption = false;
    if(option.closest('.configure-option').length > 0){
        isCustomOption = true;
    }
    return isCustomOption;
  },

  _isBundleConfigureItem: function(item){
    var isBundleConfigureItem = false;
    if(item.is(this.options.input) && item.is('[data-configurable]')){
        isBundleConfigureItem = true;
    }
    return isBundleConfigureItem;
  },

  _isLinkedItem: function(item){
	  var isLinkedItem = false;
	  if(item.is(this.options.input) && item.closest('.linked-item').length > 0){
		  isLinkedItem = true;
	  }
	  return isLinkedItem;
  },

  _updatePriceConfigureItem: function(type, option){
    var $this = this;
    var configureOptionsContainer = $(option).closest(this.options.inputParent);
    if(type === 'qty'){
        configureOptionsContainer = $(option).closest(this.options.inputParent).next(this.options.inputParentConfigure);
    }

    var configureItemBlock = configureOptionsContainer.prev(this.options.inputParent);
    var configureItem = $(this.options.input, configureItemBlock);
    var qty = $(this.options.qtyInput, configureItemBlock);

    if(configureItem.is('select')) {
        configureItem = $('option:selected', configureItem);
    }

    var configureItemId = configureItem.attr('value');

    if($(option).closest(this.options.dropdownWrapper).length > 0) {
        configureOptionsContainer = $(option).closest('.input-group.configure');
        var dropdownId = configureOptionsContainer.data('option-id');
        configureItem = $(option).closest(this.options.dropdownWrapper).find('.bundle-option-select-wrapper select option[value='+dropdownId+']');
        configureItemId = $(configureItem).attr('value');
        qty = $(this.options.qtyInput, $(option).closest(this.options.dropdownWrapper));
    }

    var optionPrice = 0;
    $('[value], .text-type', configureOptionsContainer).each(function(){
      var el = $(this);
      var value = $this._getElementValue(el);

      if(value !== '' && el.data('price')){
        var active = el[0].checked || el.is('option:selected')
            || (el.is('input[type="text"], textarea') && !/^\s*$/.test(el.val()));

        if (active) {
          optionPrice += ($this.options.basePrices[value]);
        }
      }
    });

    if(type === 'qty'){
      qty = $(option);
    }

    configureItem.data('selected-options-price', optionPrice);
    this._recalculate(qty);

    if(type === 'option'){
      this._updateSpecs();
    }

    return true;
  },

  _getElementValue: function(el) {
    var value = el.attr('value');

    if(el.is('input[type="text"], textarea')){
        value = el.data('value');
    }

    return value;
  },

  _manageCustomOptions: function(item){
    var active = item.is(':checked');
    var configureOptionsContainer = $(item).closest(this.options.inputParent).next(this.options.inputParentConfigure);
    var $this = this;

    if($(item).is('select')) {
      var selectedOption = $('option:selected', item).attr('value');
      var dropdownParent = $(item).closest(this.options.dropdownWrapper);

      $(this.options.inputParentConfigure, dropdownParent).each(function() {
        active = (selectedOption == $(this).data('option-id'));

        $this._manageRequiredAttr(active, this)
      });
    } else {
      this._manageRequiredAttr(active, configureOptionsContainer);
    }

    return true;
  },

  _manageRequiredAttr: function(flag, parent) {
    $('[data-required]', parent).each(function() {
      var el = $(this);
      if(flag) {
        el.attr('required', true);
      } else {
        el.removeAttr('required');
        el.parsley().destroy();
      }
    });

    return true;
  },

  _hideAllDropdownImages: function(optionImages) {
	  optionImages.each(function () {
		  if (!$(this).hasClass('hidden')) $(this).addClass('hidden');
	  });
  },

	_hideAllLinkedItemButtons: function(container) {
    $('.linked-item-bubble-container', container).each(function(){
	    if (!$(this).hasClass('hidden')) $(this).addClass('hidden');
    });

    $('.linked-products', container).hide();
  },

	_hideOtherDropdowns: function(item) {
    var parent = item.closest('.accordian-content');

    $('.cart-item-linked-bubble.active', parent).click();
  },

  catchEventKeyUp: function(e) {
    var $this = e.data.thiz;
    var el = $(e.target);
    if(el.is($this.options.qtyInput)) {
      el.val(el.val().replace(/[^0-9.]/g, ""));
      $this._updatePriceConfigureItem('qty', e.target);
    }
  },

  catchEventChange: function(e) {
    var $this = e.data.thiz;
    var target = $(e.target);

    $this._disableInputs();
    $this._updateSelect(target);
    $this._updateRadio(target);
    $this._updateSpecs();

    if($this._isCustomOption(target)){
      $this._updatePriceConfigureItem('option', target);
    } else if($this._isBundleConfigureItem(target)){
      $this._manageCustomOptions(target);
    }

	  if (target.is('input[type="radio"]') && target.closest('.accordian-content').find('.linked-item').length > 0) {
		  $this._hideOtherDropdowns(target);
	  }

    if ($this._isLinkedItem(target)) {
      var linkedDropdownToggle = target.closest('.linked-item').find('.cart-item-linked-bubble');

	    if ((target.is(':checked') && !linkedDropdownToggle.hasClass('active')) ||
          !target.is(':checked') && linkedDropdownToggle.hasClass('active')) {
		    linkedDropdownToggle.click();
      }
    }
  },

  throwEventUpdateProductPrice: function(e) {
    bq.debug.log("marketplace.bundle : event thrown [bq.productPrice.update]");
    this.$element.trigger('bq.productPrice.update', e);
  },

  catchEventKeyUpCustomOption: function(e) {
    var $this = e.data.thiz;

    $this._updatePriceConfigureItem('option', e.target);
  },

  catchEventValidateBundleItem: function(e) {
    var $this = e.data.thiz;

    $this.options.validateErrorMessage = bq.messages.global.itemNeedsConfiguration;

    bq.helper.throwEvent('bq.notification', null, {
      id:   'notification_needs-config',
      text: $this.options.validateErrorMessage,
      type: 'error'
    });
  },

  catchEventChangeDropdown: function(e) {
    var select = $(e.target);
    var $this = e.data.thiz;
    var selectedOption = $('option:selected', select).attr('value');
    var dropdownParent = select.closest($this.options.dropdownWrapper);
    var itemId = $('option:selected', select).data('item-id');
    var itemTitle = $('option:selected', select).data('item-title');
    var itemUrl = $('option:selected', select).data('item-url');
    var itemSku = $('option:selected', select).data('sku');
    var imageWrapper = select.closest($this.options.dropdownWrapper).find('.bundle-option-image');
    var optionImages = $('.bundle-option-image-select', imageWrapper);
	  var linkedItemButton = $('.linked-item-bubble-container[data-item-id="' + itemId + '"]', dropdownParent);
	  var itemNameContainer = $('.bundle-option-select-chosen-product-name', dropdownParent);
    var itemSkuContainer = $('.bundle-option-select-chosen-product-sku span', dropdownParent);

    $('.input-group.configure', dropdownParent).removeClass('active');

    if(selectedOption) {
      var dropdown = $('#selection_' + selectedOption + '_options');

      if(dropdown.length > 0) {
          dropdown.addClass('active');
      }

      if (linkedItemButton.length > 0) {
        $this._hideAllLinkedItemButtons(dropdownParent);
        $('.bundle-option-select-wrapper', dropdownParent).addClass('linked-item');
        linkedItemButton.removeClass('hidden');
      } else {
        $this._hideAllLinkedItemButtons(dropdownParent);
        $('.bundle-option-select-wrapper', dropdownParent).removeClass('linked-item');
      }

      $this._hideAllDropdownImages(optionImages);
      $('.bundle-option-image-select[data-item-id="' + itemId + '"]', imageWrapper).removeClass('hidden');

      $('.bundle-option-select-chosen-product', dropdownParent).removeClass('hidden');
      itemNameContainer.html('<a target="_blank" href="' + itemUrl + '">' + itemTitle + '</a>');
      itemSkuContainer.html('<a target="_blank" href="' + itemUrl + '">' + itemSku + '</a>');
    } else {
	    $this._hideAllDropdownImages(optionImages);

	    $('.bundle-option-select-chosen-product', dropdownParent).addClass('hidden');
      itemNameContainer.html();
      itemSkuContainer.html();
    }

    $this._manageCustomOptions(select);
  },

  catchToggleAll: function(e) {
    var $this = e.data.thiz;

    if (e.currentTarget.matches($this.options.bundleToggleAll)) {
      var state = e.currentTarget.dataset.state;

      $($this.options.items).each(function() {
        if (state === 'select') {
          if (!$(this).is(':checked')) {
            $(this).click();
          }
        } else {
          if ($(this).is(':checked') && !$(this).hasClass('option-input-default-checked')) {
            $(this).click();
          }
        }
      });

      if (state === 'select') {
        e.currentTarget.dataset.state = 'unselect';
      } else {
        e.currentTarget.dataset.state = 'select'
      }
    }
  },

  catchEventFormReset: function(e) {
    var $this = e.data.thiz;

    $($this.options.dropdown, $this.element).each(function() {
      $(this).val('').trigger('change');
      bq.global.parsley.destroySingle(this)
    });

    $($this.options.qtyInput, $this.element).each(function(){
      $this._recalculate($(this));
    });
  }

};

$('[data-bq="product-bundle"]').each(function () {
  bq.bundle.init(this);
});
